import { MINUTE, HOUR, DAY } from 'constants/date'

const WEEK = DAY * 7
const MONTH_THRESHOLD = DAY * 29 // 29 days or more shows exact date

enum TimeRange {
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS',
  WEEKS = 'WEEKS',
  EXACT_DATE = 'EXACT_DATE',
}

const getTimeRange = (diff: number): TimeRange => {
  if (diff < HOUR) return TimeRange.MINUTES
  if (diff < DAY) return TimeRange.HOURS
  if (diff < WEEK) return TimeRange.DAYS
  if (diff < MONTH_THRESHOLD) return TimeRange.WEEKS
  return TimeRange.EXACT_DATE
}

const formatExactDate = (date: Date): string => {
  const now = new Date()
  // Use toLocaleString to get the abbreviated month name in UTC
  const month = date.toLocaleString('en-US', {
    month: 'short',
    timeZone: 'UTC',
  })
  const day = date.getUTCDate()
  const year = date.getUTCFullYear()
  const currentYear = now.getUTCFullYear()

  if (year === currentYear) {
    return `${month} ${day}`
  }

  return `${month} ${day}, ${year}`
}

export const getPastTimestamp = (timestamp: string): string => {
  const now = Date.now()
  const pastTime = new Date(timestamp).getTime()
  const diff = Math.max(0, now - pastTime)

  const timeRange = getTimeRange(diff)

  switch (timeRange) {
    case TimeRange.MINUTES: {
      const minutes = Math.floor(diff / MINUTE)
      return `${minutes}m`
    }

    case TimeRange.HOURS: {
      const hours = Math.floor(diff / HOUR)
      return `${hours}h`
    }

    case TimeRange.DAYS: {
      const days = Math.floor(diff / DAY)
      return `${days}d`
    }

    case TimeRange.WEEKS: {
      const weeks = Math.floor(diff / WEEK)
      return `${weeks}w`
    }

    case TimeRange.EXACT_DATE: {
      return formatExactDate(new Date(timestamp))
    }

    default:
      return formatExactDate(new Date(timestamp))
  }
}

export default getPastTimestamp
